import { DecoratorNode, NodeKey, SerializedLexicalNode, Spread } from "lexical";
import { ReactNode } from "react";

export type SkillPayload = {
  id: string;
  name: string;
};

export type SerializedSkillNode = Spread<
  {
    skill: SkillPayload;
    version: 1;
  },
  SerializedLexicalNode
>;

export class SkillNode extends DecoratorNode<ReactNode> {
  __skill: SkillPayload;

  static getType(): string {
    return "skill";
  }

  static clone(node: SkillNode): SkillNode {
    return new SkillNode(node.__skill, node.__key);
  }

  static importJSON(serializedNode: SerializedSkillNode): SkillNode {
    return $createSkillNode(serializedNode.skill);
  }

  constructor(skill: SkillPayload, key?: NodeKey) {
    super(key);
    this.__skill = skill;
  }

  getType(): string {
    return "skill";
  }

  getSkill(): SkillPayload {
    const self = this.getLatest();
    return self.__skill;
  }

  createDOM(): HTMLElement {
    return document.createElement("span");
  }

  getTextContent() {
    const skill = this.getLatest().__skill;
    return `{skill:${skill.id}:${skill.name}}`;
  }

  updateDOM(): boolean {
    return false;
  }

  exportJSON(): SerializedSkillNode {
    return {
      type: this.getType(),
      skill: this.getSkill(),
      version: 1,
    };
  }

  decorate(): ReactNode {
    const self = this.getLatest();

    return <strong>{`/${self.__skill.name}`}</strong>;
  }
}

export function $createSkillNode(skill: SkillPayload): SkillNode {
  return new SkillNode(skill);
}

export function $isSkillNode(node: any): node is SkillNode {
  return node instanceof SkillNode;
}
